// src/features/medicine-inventory/services/api.js
// patientsApi.js
import httpClient from '../../../shared/services/httpClient';
import {
  mockCategories,
  mockMedicines,
  mockStockMovements,
  mockPatients,
  mockVisits,
  mockPrescriptions
} from './mockData';

// Simulate API delay
const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

class ApiService {
  constructor() {
    // Initialize with mock data
    this.categories = [...mockCategories];
    this.medicines = [...mockMedicines];
    this.stockMovements = [...mockStockMovements];
    this.patients = [...mockPatients];
    this.visits = [...mockVisits];
    this.prescriptions = [...mockPrescriptions];

    console.log('API Service initialized with mock data:', {
      categories: this.categories.length,
      medicines: this.medicines.length,
      stockMovements: this.stockMovements.length,
      patients: this.patients.length,
      visits: this.visits.length,
      prescriptions: this.prescriptions.length
    });
  }

  // Patients API
  async getPatients(params = { paginate: true, per_page: 10 }) {
    //await delay(500);
    const response = await httpClient.get('/patients', { params });
    //return response.data;
    return { data: response.data };
  }


  // // Get single patient by ID
  // getPatient: async (id) => {
  //   const response = await httpClient.get(`/patients/${id}`);
  //   return response.data;
  // }


  async getPatient(id) {
    await delay(300);
    const patient = this.patients.find(p => p.id === id);
    return { data: patient };
  }

  // async searchPatients(query) {
  //   await delay(300);
  //   const results = this.patients.filter(p => 
  //     p.name.toLowerCase().includes(query.toLowerCase()) ||
  //     p.patientId.toLowerCase().includes(query.toLowerCase()) ||
  //     p.contact.includes(query)
  //   );
  //   return { data: results };
  // }


  async searchPatients(query, page = 1, perPage = 10) {
    const response = await httpClient.get('/patients', {
      params: {
        page: page,
        per_page: perPage,
        search: query
      }
    });

    return { data: response.data.data };
  }
  // Visits API
  async getVisits() {
    await delay(500);
    return { data: this.visits };
  }

  async getPatientVisits(patientId) {

    const response = await httpClient.get(`/visits/patient/${patientId}/history`);

    return { data: response.data.data };

  }



  async getVisit(id) {
    await delay(300);
    const visit = this.visits.find(v => v.id === id);
    return { data: visit };
  }

  // Prescriptions API
  async getPrescriptions() {
    await delay(500);
    return { data: this.prescriptions };
  }

  async getPatientPrescriptions(patientId) {
   // await delay(300);
    const response = await httpClient.get(`/prescriptions/patient/${patientId}/active`);

    return { data: response.data.data };
  }

  async getVisitPrescriptions(visitId) {
    const response = await httpClient.get(`prescriptions/visit/${visitId}`);

    return { data: response.data.data };
    
  }

  async getPrescription(id) {
    await delay(300);
    const prescription = this.prescriptions.find(p => p.id === id);
    return { data: prescription };
  }

  // Categories API
  async getCategories() {
    await delay(500);
    return { data: this.categories };
  }

  async getCategory(id) {
    await delay(300);
    const category = this.categories.find(c => c.id === id);
    return { data: category };
  }

  async createCategory(categoryData) {
    await delay(500);
    const newCategory = {
      ...categoryData,
      id: Date.now().toString(),
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString()
    };
    this.categories.push(newCategory);
    return { data: newCategory };
  }

  async updateCategory(id, categoryData) {
    await delay(500);
    const index = this.categories.findIndex(c => c.id === id);
    if (index !== -1) {
      this.categories[index] = {
        ...this.categories[index],
        ...categoryData,
        updatedAt: new Date().toISOString()
      };
      return { data: this.categories[index] };
    }
    throw new Error('Category not found');
  }

  async deleteCategory(id) {
    await delay(500);
    this.categories = this.categories.filter(c => c.id !== id);
    return { data: { success: true } };
  }

  // Medicines API
  async getMedicines() {
   // await delay(500);
        const response = await httpClient.get(`/stock/medicines?paginate=true&page=1&per_page=200`);
    return { data: response.data.data };
  }

  async getMedicine(id) {
    await delay(300);
    const medicine = this.medicines.find(m => m.id === id);
    return { data: medicine };
  }

  async createMedicine(medicineData) {
    await delay(500);
    const category = this.categories.find(c => c.id === medicineData.categoryId);
    const newMedicine = {
      ...medicineData,
      id: Date.now().toString(),
      category: category?.name || 'Unknown',
      currentStock: 0,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString()
    };
    this.medicines.push(newMedicine);
    return { data: newMedicine };
  }

  async updateMedicine(id, medicineData) {
    await delay(500);
    const index = this.medicines.findIndex(m => m.id === id);
    if (index !== -1) {
      const category = this.categories.find(c => c.id === medicineData.categoryId);
      this.medicines[index] = {
        ...this.medicines[index],
        ...medicineData,
        category: category?.name || this.medicines[index].category,
        updatedAt: new Date().toISOString()
      };
      return { data: this.medicines[index] };
    }
    throw new Error('Medicine not found');
  }

  async deleteMedicine(id) {
    await delay(500);
    this.medicines = this.medicines.filter(m => m.id !== id);
    return { data: { success: true } };
  }

  // Stock Movements API
  async getStockMovements() {
    await delay(500);
    return { data: this.stockMovements };
  }

  async getStockMovementsByMedicine(medicineId) {
    await delay(300);
    const movements = this.stockMovements.filter(m =>
      m.type === 'MULTI_ISSUE'
        ? m.medicines?.some(med => med.medicineId === medicineId)
        : m.medicineId === medicineId
    );
    return { data: movements };
  }

  // Single medicine movement
  async createStockMovement(movementData) {
    await delay(500);
    const medicine = this.medicines.find(m => m.id === movementData.medicineId);

    const newMovement = {
      ...movementData,
      id: Date.now().toString(),
      medicineName: medicine?.name || 'Unknown',
      createdAt: new Date().toISOString()
    };

    // Update medicine stock
    if (medicine) {
      const medicineIndex = this.medicines.findIndex(m => m.id === medicine.id);
      if (movementData.type === 'PURCHASE') {
        this.medicines[medicineIndex].currentStock += parseInt(movementData.quantity);
      } else if (movementData.type === 'ISSUE') {
        this.medicines[medicineIndex].currentStock -= parseInt(movementData.quantity);
      }
    }

    this.stockMovements.push(newMovement);
    return { data: newMovement };
  }

  // Multi-medicine issue
  // async createMultiMedicineIssue(issueData) {
  //   await delay(500);

  //   const newIssue = {
  //     id: Date.now().toString(),
  //     type: 'MULTI_ISSUE',
  //     patientId: issueData.patientId,
  //     patientName: issueData.patientName,
  //     visitId: issueData.visitId,
  //     prescriptionId: issueData.prescriptionId,
  //     doctorName: issueData.doctorName,
  //     issueDate: new Date().toISOString(),
  //     medicines: [],
  //     totalAmount: 0,
  //     notes: issueData.notes
  //   };

  //   // Process each medicine in the issue
  //   for (const item of issueData.medicines) {
  //     const medicine = this.medicines.find(m => m.id === item.medicineId);

  //     if (medicine) {
  //       const medicineIndex = this.medicines.findIndex(m => m.id === medicine.id);
  //       const itemTotal = item.quantity * item.unitPrice;

  //       // Update medicine stock
  //       this.medicines[medicineIndex].currentStock -= parseInt(item.quantity);

  //       // Add to medicines array
  //       newIssue.medicines.push({
  //         medicineId: item.medicineId,
  //         medicineName: medicine.name,
  //         quantity: parseInt(item.quantity),
  //         unitPrice: parseFloat(item.unitPrice),
  //         totalPrice: itemTotal,
  //         dosage: item.dosage,
  //         instructions: item.instructions
  //       });

  //       newIssue.totalAmount += itemTotal;
  //     }
  //   }

  //   this.stockMovements.push(newIssue);
  //   return { data: newIssue };
  // }

  // Multi-medicine issue
async createMultiMedicineIssue(issueData) {
  try {

    const response = await httpClient.post(
      '/stock/stock/multiissue',
      issueData
    );

    return response.data;

  } catch (error) {
    console.error('Multi medicine issue failed', error);
    throw error;
  }
}

async createMultiMedicinePurchase(purchaseData) {
  try {

    const response = await httpClient.post(
      '/stock/stock/multipurchase',
      purchaseData
    );

    return response.data;

  } catch (error) {
    console.error('Multi medicine issue failed', error);
    throw error;
  }
}
}

// Create and export a single instance
const apiService = new ApiService();
export default apiService;